import React, { useState } from 'react';

import { useSearchParams, useLocation } from 'react-router-dom';
import { PaymentStatus } from 'shared';
import { useStripeStatus } from 'shared/api/getStripeStatus';

import NotFoundPage from 'pages/NotFoundPage';
import { Success } from '../paymentStatusPages/Success/Success';
import { Fail } from '../paymentStatusPages/Fail/Fail';
import { InProgress } from '../paymentStatusPages/InProgress/InProgress';
import { getRouteMain, isRussiaRoute } from 'shared/consts';

type TelegramWindow = Window & {
  Telegram?: {
    WebApp?: {
      close?: () => void;
    };
  };
  TelegramWebviewProxy?: {
    postEvent?: (eventType: string, eventData: string) => void;
  };
};

function isTelegramWebApp() {
  const telegramWindow = window as TelegramWindow;

  return Boolean(telegramWindow.Telegram?.WebApp || telegramWindow.TelegramWebviewProxy);
}

function closeTelegramWebApp() {
  const telegramWindow = window as TelegramWindow;

  if (telegramWindow.Telegram?.WebApp?.close) {
    telegramWindow.Telegram.WebApp.close();
    return true;
  }

  if (telegramWindow.TelegramWebviewProxy?.postEvent) {
    telegramWindow.TelegramWebviewProxy.postEvent('web_app_close', '{}');
    return true;
  }

  return false;
}

const StripeCallbackPage: React.FC = () => {
  const [params] = useSearchParams();
  const paymentId = params.get("payment_id");
  const { pathname } = useLocation();
  const returnLink = params.get("returnLink");
  const fallbackReturnLink = isRussiaRoute(pathname)
    ? getRouteMain(pathname) : returnLink ?? getRouteMain(pathname);
  const [getStripeStatus] = useStripeStatus();
  const [stripeStatus, setStripeStatus] = useState<PaymentStatus>("IN_PROGRESS");

  React.useEffect(
  () => {
    if (paymentId === null) return;
    getStripeStatus( { paymentId } )
    .unwrap()
    .then((data) => {
      setStripeStatus(data.paymentStatus);
    })
    .catch(() => {setStripeStatus("FAIL")});
  },[])

  React.useEffect(() => {
    if (stripeStatus !== "SUCCESS") return;
    if (!isTelegramWebApp()) return;
    closeTelegramWebApp();
  }, [stripeStatus])

  if (paymentId === null) return <NotFoundPage/>;
  return stripeStatus === "SUCCESS" ? <Success returnLink={fallbackReturnLink}/> :
         stripeStatus === "IN_PROGRESS" ? <InProgress returnLink={fallbackReturnLink}/> :
         <Fail returnLink={fallbackReturnLink}/>
};

export { StripeCallbackPage };
